import {
  type TrustCheckViewModel,
  useTrustChecksViewModel,
} from "@/hooks/matter-view-models/use-trust-checks-view-model";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import type { MatterLien } from "@/lib/types";
import { useSuspenseQuery } from "@tanstack/react-query";

export type LienViewModel = MatterLien & {
  trustChecks: TrustCheckViewModel[];
};

export const getLienId = (lien: Pick<MatterLien, "id">) => lien.id;

export const useLiensViewModel = (matterId: string) => {
  const { data: matterData } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );
  const matter = matterData.data;
  const trustChecksViewModel = useTrustChecksViewModel(matterId);

  return matter.liens.map((lien) => {
    const lienId = getLienId(lien);
    const trustChecks = trustChecksViewModel.filter((trustCheck) =>
      trustCheck.connections.some((connection) => connection.lienId === lienId),
    );
    return {
      ...lien,
      trustChecks,
    } as LienViewModel;
  });
};
